import React from 'react';

import { uiRoutes } from '@consumer-frontend/nc-api';

import { creditReportDisclosure } from './creditReportDisclosure';
import { electronicCommunicationDisclosure } from './electronicCommunicationDisclosure';
import { emailCommunicationDisclosure } from './emailCommunicationDisclosure';
import { NcButtonStyledAsLink } from '../NcButtonStyledAsLink';
import { NcCheckbox } from '../NcCheckbox';
import { NcExternalLink } from '../NcExternalLink';
import { NcModalAnchor } from '../NcModal';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/consents.scss';

export type NcConsentBundlePropsT = {
  checked?: boolean;
  defaultChecked?: boolean;
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const NcConsentBundle = ({
  checked,
  defaultChecked,
  errorMessage,
  onChange,
}: NcConsentBundlePropsT) => {
  // CodeCov can't handle multi-line statements wrapped in (...) so ignoring this line for coverage purposes.
  // istanbul ignore next -- @preserve
  const label = (
    <span className="fineprint consent-text">
      By clicking this checkbox, I confirm that I have reviewed and agree to{' '}
      <NcModalAnchor
        title="Consent to Email Communication under 12 CFR § 1041"
        body={emailCommunicationDisclosure.v1}
        primaryText="Close"
      >
        <NcButtonStyledAsLink>
          Consent to Email Communication under 12 CFR § 1041
        </NcButtonStyledAsLink>
      </NcModalAnchor>
      {', '}
      <NcModalAnchor
        title={
          <>
            Consent to Electronic Communication under 15 U.S.C. § 7001, <em>et seq.</em>
          </>
        }
        body={electronicCommunicationDisclosure.v1}
        primaryText="Close"
      >
        <NcButtonStyledAsLink>
          Consent to Electronic Communication under 15 U.S.C. § 7001, et seq.
        </NcButtonStyledAsLink>
      </NcModalAnchor>
      {', '}
      <NcModalAnchor
        title="Consent to Obtain Credit Reports"
        body={creditReportDisclosure.v1}
        primaryText="Close"
      >
        <NcButtonStyledAsLink>
          Consent to Obtain Credit Reports
        </NcButtonStyledAsLink>
      </NcModalAnchor>
      {', '}
      <NcExternalLink href={uiRoutes.legacyAH.privacyPolicy}>
        NetCredit Privacy Policy
      </NcExternalLink>
      {', '}
      <NcExternalLink href={uiRoutes.legacyAH.statesPrivacyPolicy}>
        States Privacy Policy
      </NcExternalLink>
      {' and '}
      <NcExternalLink href={uiRoutes.legacyAH.termsOfUse}>
        Terms of Use
      </NcExternalLink>
      {', and '}
      <NcExternalLink href={uiRoutes.legacyAH.rbtPrivacyPolicy}>
        Republic Bank &amp; Trust Privacy Policy
      </NcExternalLink>
      {' and '}
      <NcExternalLink href={uiRoutes.legacyAH.qbPrivacyNotice}>
        Quill Bank Privacy Notice
      </NcExternalLink>
      .
    </span>
  );

  return (
    <NcCheckbox
      id="consent-bundle"
      name="consent-bundle"
      label={label}
      checked={checked}
      defaultChecked={defaultChecked}
      errorMessage={errorMessage}
      onChange={onChange}
    />
  );
};
